import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { isAdminOrEditor, isEditor } from '../../../helpers';
import Icon from '@projeccions-pdc/react-icon';
import { getDownloadLink, getPlatform } from '../ContainerAppDownloader';
import { withRouter } from 'react-router-dom';
import UserSettingsModal from '../../Home/UserSettingsModal';
import AuthController from '../../Auth/AuthController';
import './Etc.css';

import LocalizedStrings from '../../Localization/localization';
import AppContext from '../../../AppContext';
import { /*ToolsData*/ ToolsDataPerPlatformId } from '../../../ToolsList';
class EtcMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            logoutLoading: false,
            userSettingsIsOpen: false,
            platformId: new AppContext().getPlatformId(),
        };
        this.handleEtcClick = this.handleEtcClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleInsideBackendClick = this.handleInsideBackendClick.bind(this);
        // console.log('APPCONTEXT', new AppContext().getPlatformId());
    }

    handleEtcClick() {
        this.setState({ open: !this.state.open });
    }

    handleClickOutside(evt) {
        if (this.state.userSettingsIsOpen === true) return;
        this.setState({ open: false });
    }
    goToRoute = (evt, uri) => {
        if (evt && (evt.ctrlKey || evt.metaKey)) {
            window.open(uri, '_blank');
        } else {
            this.context.router.history.push(uri);
        }
    };
    handleInsideBackendClick(frame) {
        let url = this.context.router.route.match.url;
        if (frame === 'backend') {
            if (url.indexOf('edit') === -1) {
                url = '/category/show';
            } else {
                url = url.replace('edit', 'show');
            }
        } else {
            url = url.replace('show', 'edit');
        }
        this.context.router.history.push(url);
        this.handleEtcClick();
    }

    handleDownloadApp = () => {
        let link = getDownloadLink();
        if (link !== undefined) {
            window.open(link, '_blank');
        }
    };

    toggleUserSettings = (newOpen) => {
        let newValue = !this.state.userSettingsIsOpen;
        if (newOpen !== undefined) {
            newValue = newOpen;
        }
        this.setState({ userSettingsIsOpen: newValue });
    };

    logOut = async () => {
        this.setState({ logoutLoading: true });
        await AuthController.signOut(this.props.history);
        this.setState({ logoutLoading: false });
    };

    render() {
        const isAdminVar = isAdminOrEditor();
        const isEditorVar = isEditor();
        return (
            <div>
                <div className="fe-menu-button fe-etc-button" onClick={this.handleEtcClick}>
                    <Icon name="md-more-vert" size={'20px'} />
                </div>
                {this.state.open ? (
                    <div className="fe-etc-container fe-context-window">
                        <div className="arrow-up"></div>
                        <div className="fe-popup-content">
                            <div className="fe-etc-content">
                                {isAdminOrEditor() === true && this.props.isOnline === true ? (
                                    this.props.isInside ? (
                                        <div
                                            className="fe-menu-item-bottom-border"
                                            data-id="go-editor-btn"
                                            onClick={() => {
                                                this.handleInsideBackendClick('inside');
                                            }}
                                        >
                                            <Icon name="md-edit" size={'20px'} />
                                            <span style={{ marginLeft: '10px' }}>{'Content Editor'}</span>
                                        </div>
                                    ) : (
                                        <div
                                            className="fe-menu-item-bottom-border"
                                            data-id="go-inside-btn"
                                            onClick={() => {
                                                this.handleInsideBackendClick('backend');
                                            }}
                                        >
                                            <Icon name="md-public" size={'20px'} />
                                            <span style={{ marginLeft: '10px' }}>{'View Online'}</span>
                                        </div>
                                    )
                                ) : (
                                    ''
                                )}

                                {this.props.smartphoneView &&
                                    ToolsDataPerPlatformId(this.state.platformId).map((route) => {
                                        if (route.etcSmartphone !== true) {
                                            return '';
                                        }

                                        if (isAdminVar === false && route.role === 'admin') {
                                            return '';
                                        }

                                        if (isAdminVar === false && isEditorVar === false && route.role === 'adminoreditor') {
                                            return '';
                                        }

                                        return (
                                            <div
                                                key={route.title}
                                                className="fe-menu-item-bottom-border"
                                                onClick={(evt) => this.goToRoute(evt, route.uri)}
                                            >
                                                <span style={{ marginRight: '10px' }}>
                                                    <Icon name={route.iconElement} />
                                                </span>
                                                {LocalizedStrings[route.title]}
                                            </div>
                                        );
                                    })}

                                {process.env.REACT_APP_IS_CONTAINER !== 'true' && (
                                    <div className="fe-menu-item-bottom-border" onClick={this.handleDownloadApp}>
                                        <span style={{ marginRight: '10px' }}>
                                            <Icon name="md-file-download" size={'20px'} />
                                        </span>
                                        {getDownloadLink() !== undefined
                                            ? `Download app for ${getPlatform()}`
                                            : 'App not avaliable for your device'}
                                    </div>
                                )}
                                {/* <div className='fe-etc-analytics'
                                    onClick={() => { this.context.router.history.push('/analytics'); }}>
                                    Analytics
                                </div>
                                <div className='fe-etc-download' onClick={() => { this.props.openModal('DownloadModal'); }}>
                                    Descarrega l'app
                                </div>
                                <div className='fe-etc-devices' onClick={() => { this.props.openModal('DevicesModal'); }}>
                                    Els meus dispositius
                                </div>
                                <div className='fe-etc-password' onClick={() => { this.props.openModal('PasswordModal'); }}>
                                    Canvia la contrasenya
                                </div>
                                <div className="fe-menu-item-bottom-border fe-etc-help fe-menu-item-bottom-border" onClick={() => { this.props.openModal('HelpModal'); }}>
                                    Ajuda
                                </div> */}
                                <div className="fe-menu-item-bottom-border">
                                    <UserSettingsModal
                                        fullWidth={true}
                                        notify={this.props.notify}
                                        isOnline={this.props.isOnline}
                                        toggleUserSettings={this.toggleUserSettings}
                                    >
                                        <div>
                                            <span style={{ marginRight: '10px' }}>
                                                <Icon name="fa-user" size={'20px'} />
                                            </span>
                                            {'User Settings'}
                                        </div>
                                    </UserSettingsModal>
                                </div>

                                {this.props.isOnline === true && (
                                    <div onClick={this.logOut}>
                                        <Icon name="md-exit-to-app" size={'20px'} />
                                        <span style={{ marginLeft: '10px' }}>{'Log Out'}</span>
                                        {this.state.logoutLoading ? (
                                            <div className="fe-etc-logout-loading">
                                                <Icon name="fa-refresh" />
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}
EtcMenu.propTypes = {
    history: PropTypes.object,
    isInside: PropTypes.bool.isRequired,
    isOnline: PropTypes.bool,
    notify: PropTypes.func.isRequired,
};
EtcMenu.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};
const Etc = onClickOutside(EtcMenu);
export default withRouter(Etc);
